import {custom, deserialize, list, serialize, SKIP} from "serializr";
import {SmartOfferBundle} from "./SmartOfferBundle";
import {SmartOfferBundleKind} from "./SmartOfferBundleKind";
import {SmartOfferBundleShop} from "../bundle-shop/SmartOfferBundleShop";
import {SmartOfferBundleMarket} from "../bundle-market/SmartOfferBundleMarket";
import {SmartOfferBundleCascade} from "../bundle-cascade/SmartOfferBundleCascade";
import {SmartOfferBundleFirefly} from "../bundle-firefly/SmartOfferBundleFirefly";
import {SmartOfferBundleAchievement} from "../bundle-achievement/SmartOfferBundleAchievement";
import {SmartOfferBundleTreasure} from "../bundle-treasure/SmartOfferBundleTreasure";
import {SmartOfferBundleProgressive} from "../bundle-progressive/SmartOfferBundleProgressive";
import {SmartOfferBundleMasterSeason} from "@/modules/redactor/models/smart-offer/bundle-master-season/SmartOfferBundleMasterSeason";
import {SmartOfferBundleSunkenRuins} from "../bundle-sunken-ruins/SmartOfferBundleSunkenRuins";
import {SmartOfferBundleAncientTreasure} from "@/modules/redactor/models/smart-offer/bundle-ancient-treasure/SmartOfferBundleAncientTreasure";
import {SmartOfferBundleCollection} from "@/modules/redactor/models/smart-offer/bundle-collection/SmartOfferBundleCollection";
import {SmartOfferBundleDailyPass} from "@/modules/redactor/models/smart-offer/bundle-daily-pass/SmartOfferBundleDailyPass";
import {SmartOfferBundleDecoration} from "@/modules/redactor/models/smart-offer/bundle-decoration/SmartOfferBundleDecoration";
import {SmartOfferBundleHiddenTemple} from "../bundle-hidden-temple/SmartOfferBundleHiddenTemple";
import {SmartOfferBundleAlchemy} from "@/modules/redactor/models/smart-offer/bundle-alchemy/SmartOfferBundleAlchemy";
import {SmartOfferBundleTimeLimited} from "@/modules/redactor/models/smart-offer/bundle-time-limited/SmartOfferBundleTimeLimited";
import {SmartOfferBundleAnyPurchase} from "@/modules/redactor/models/smart-offer/bundle-any-purchase/SmartOfferBundleAnyPurchase";
import {SmartOfferBundleMultiTab} from "@/modules/redactor/models/smart-offer/bundle-multi-tab/SmartOfferBundleMultiTab";
import {SmartOfferBundleTreasureAchievement} from "@/modules/redactor/models/smart-offer/bundle-treasure-achievement/SmartOfferBundleTreasureAchievement";
import {SmartOfferBundlePlinko} from "@/modules/redactor/models/smart-offer/bundle-plinko/SmartOfferBundlePlinko";
import {SmartOfferBundleMagicSpin} from "@/modules/redactor/models/smart-offer/bundle-magic-spin/SmartOfferBundleMagicSpin";
import {SmartOfferBundleTreasureOffer} from "@/modules/redactor/models/smart-offer/bundle-treasure-shop/SmartOfferBundleTreasureOffer";
import {SmartOfferBundleTreasureShop} from "@/modules/redactor/models/smart-offer/bundle-treasure-offer/SmartOfferBundleTreasureShop";
import {SmartOfferBundlePlinkoShopSimple} from "@/modules/redactor/models/smart-offer/bundle-plinko-shop/SmartOfferBundlePlinkoShopSimple";
import {SmartOfferBundlePlinkoShopDouble} from "@/modules/redactor/models/smart-offer/bundle-plinko-shop/SmartOfferBundlePlinkoShopDouble";
import {SmartOfferBundleOnePlusTwo} from "@/modules/redactor/models/smart-offer/bundle-one-plus-two/SmartOfferBundleOnePlusTwo";
import {SmartOfferBundleCardBoxBank} from "@/modules/redactor/models/smart-offer/bundle-card-box-bank/SmartOfferBundleCardBoxBank";
import {SmartOfferBundleTreasureTree} from "@/modules/redactor/models/smart-offer/bundle-expd-treasure/SmartOfferBundleTreasureTree";
import {SmartOfferBundleTreasureGate} from "@/modules/redactor/models/smart-offer/bundle-expd-treasure/SmartOfferBundleTreasureGate";
import {SmartOfferBundleNoviceBattlePass} from "@/modules/redactor/models/smart-offer/bundle-novice-battle-pass/SmartOfferBundleNoviceBattlePass";
import {SmartOfferBundlePiggy} from "@/modules/redactor/models/smart-offer/bundle-piggy/SmartOfferBundlePiggy";
import {SmartOfferBundleRewardGiver} from "@/modules/redactor/models/smart-offer/bundle-reward-giver/SmartOfferBundleRewardGiver";
import {SmartOfferBundleChristmasHub} from "@/modules/redactor/models/smart-offer/bundle-christmas-hub/SmartOfferBundleChristmasHub";
import {SmartOfferBundleChristmasCalendar} from "@/modules/redactor/models/smart-offer/bundle-christmas-calendar/SmartOfferBundleChristmasCalendar";
import {SmartOfferBundleChristmas} from "@/modules/redactor/models/smart-offer/bundle-christmas/SmartOfferBundleChristmas";
import {SmartOfferBundleExpeditionGroup} from "@/modules/redactor/models/smart-offer/bundle-expedition-group/SmartOfferBundleExpeditionGroup";
import {SmartOfferBundleEnergyRefill} from "@/modules/redactor/models/smart-offer/bundle-energy-refill/SmartOfferBundleEnergyRefill";
import {SmartOfferBundleFlashAd} from "@/modules/redactor/models/smart-offer/bundle-flash-ad/SmartOfferBundleFlashAd";
import {SmartOfferBundleMagicalCinema} from "@/modules/redactor/models/smart-offer/bundle-magical-cinema/SmartOfferBundleMagicalCinema";
import {SmartOfferBundleHub} from "@/modules/redactor/models/smart-offer/bundle-hub/SmartOfferBundleHub";

export class SmartOfferBundleUtils {

    static create(kind) {
        if (SmartOfferBundleKind.SHOP.equal(kind)) {
            return new SmartOfferBundleShop();
        } else if (SmartOfferBundleKind.MARKET.equal(kind)) {
            return new SmartOfferBundleMarket();
        } else if (SmartOfferBundleKind.CASCADE.equal(kind)) {
            return new SmartOfferBundleCascade();
        } else if (SmartOfferBundleKind.FIREFLY.equal(kind)) {
            return new SmartOfferBundleFirefly();
        } else if (SmartOfferBundleKind.ACHIEVEMENT.equal(kind)) {
            return new SmartOfferBundleAchievement();
        } else if (SmartOfferBundleKind.TREASURE.equal(kind)) {
            return new SmartOfferBundleTreasure();
        } else if (SmartOfferBundleKind.PROGRESSIVE.equal(kind)) {
            return new SmartOfferBundleProgressive();
        } else if (SmartOfferBundleKind.MASTER_SEASON.equal(kind)) {
            return new SmartOfferBundleMasterSeason();
        } else if (SmartOfferBundleKind.SUNKEN_RUINS.equal(kind)) {
            return new SmartOfferBundleSunkenRuins();
        } else if (SmartOfferBundleKind.ANCIENT_TREASURE.equal(kind)) {
            return new SmartOfferBundleAncientTreasure();
        } else if (SmartOfferBundleKind.COLLECTION.equal(kind)) {
            return new SmartOfferBundleCollection();
        } else if (SmartOfferBundleKind.DAILY_PASS.equal(kind)) {
            return new SmartOfferBundleDailyPass();
        } else if (SmartOfferBundleKind.DECORATION.equal(kind)) {
            return new SmartOfferBundleDecoration();
        } else if (SmartOfferBundleKind.HIDDEN_TEMPLE.equal(kind)) {
            return new SmartOfferBundleHiddenTemple();
        } else if (SmartOfferBundleKind.ALCHEMY.equal(kind)) {
            return new SmartOfferBundleAlchemy();
        } else if (SmartOfferBundleKind.TIME_LIMITED.equal(kind)) {
            return new SmartOfferBundleTimeLimited();
        } else if (SmartOfferBundleKind.ANY_PURCHASE.equal(kind)) {
            return new SmartOfferBundleAnyPurchase();
        } else if (SmartOfferBundleKind.MULTI_TAB.equal(kind)) {
            return new SmartOfferBundleMultiTab();
        } else if (SmartOfferBundleKind.TREASURE_ACHIEVEMENT.equal(kind)) {
            return new SmartOfferBundleTreasureAchievement();
        } else if (SmartOfferBundleKind.PLINKO.equal(kind)) {
            return new SmartOfferBundlePlinko();
        } else if (SmartOfferBundleKind.PLINKO_SHOP_SIMPLE.equal(kind)) {
            return new SmartOfferBundlePlinkoShopSimple();
        } else if (SmartOfferBundleKind.PLINKO_SHOP_DOUBLE.equal(kind)) {
            return new SmartOfferBundlePlinkoShopDouble();
        } else if (SmartOfferBundleKind.MAGIC_SPIN.equal(kind)) {
            return new SmartOfferBundleMagicSpin();
        } else if (SmartOfferBundleKind.TREASURE_OFFER.equal(kind)) {
            return new SmartOfferBundleTreasureOffer();
        } else if (SmartOfferBundleKind.TREASURE_SHOP.equal(kind)) {
            return new SmartOfferBundleTreasureShop();
        } else if (SmartOfferBundleKind.ONE_PLUS_TWO.equal(kind)) {
            return new SmartOfferBundleOnePlusTwo();
        } else if (SmartOfferBundleKind.CARD_BOX_BANK.equal(kind)) {
            return new SmartOfferBundleCardBoxBank();
        } else if (SmartOfferBundleKind.EXPEDITION_TREASURE_GATE.equal(kind)) {
            return new SmartOfferBundleTreasureGate();
        } else if (SmartOfferBundleKind.EXPEDITION_TREASURE_TREE.equal(kind)) {
            return new SmartOfferBundleTreasureTree();
        } else if (SmartOfferBundleKind.NOVICE_BATTLE_PASS.equal(kind)) {
            return new SmartOfferBundleNoviceBattlePass();
        } else if (SmartOfferBundleKind.PIGGY.equal(kind)) {
            return new SmartOfferBundlePiggy();
        } else if (SmartOfferBundleKind.REWARD_GIVER.equal(kind)) {
            return new SmartOfferBundleRewardGiver();
        } else if (SmartOfferBundleKind.CHRISTMAS_HUB.equal(kind)) {
            return new SmartOfferBundleChristmasHub();
        } else if (SmartOfferBundleKind.CHRISTMAS_CALENDAR.equal(kind)) {
            return new SmartOfferBundleChristmasCalendar();
        } else if (SmartOfferBundleKind.CHRISTMAS.equal(kind)) {
            return new SmartOfferBundleChristmas();
        } else if (SmartOfferBundleKind.EXPEDITION_GROUP.equal(kind)) {
            return new SmartOfferBundleExpeditionGroup();
        } else if (SmartOfferBundleKind.ENERGY_REFILL.equal(kind)) {
            return new SmartOfferBundleEnergyRefill();
        } else if (SmartOfferBundleKind.FLASH_AD.equal(kind)) {
            return new SmartOfferBundleFlashAd();
        } else if (SmartOfferBundleKind.MAGICAL_CINEMA.equal(kind)) {
            return new SmartOfferBundleMagicalCinema();
        } else if (SmartOfferBundleKind.HUB.equal(kind)) {
            return new SmartOfferBundleHub();
        }

        console.error("unknown kind");
        return null;
    }

    static serialize(value) {
        if (!(value instanceof SmartOfferBundle)) {
            console.error("invalid type");
        } else if (SmartOfferBundleKind.SHOP.equal(value.kind)) {
            return serialize(SmartOfferBundleShop, value);
        } else if (SmartOfferBundleKind.MARKET.equal(value.kind)) {
            return serialize(SmartOfferBundleMarket, value);
        } else if (SmartOfferBundleKind.CASCADE.equal(value.kind)) {
            return serialize(SmartOfferBundleCascade, value);
        } else if (SmartOfferBundleKind.FIREFLY.equal(value.kind)) {
            return serialize(SmartOfferBundleFirefly, value);
        } else if (SmartOfferBundleKind.ACHIEVEMENT.equal(value.kind)) {
            return serialize(SmartOfferBundleAchievement, value);
        } else if (SmartOfferBundleKind.TREASURE.equal(value.kind)) {
            return serialize(SmartOfferBundleTreasure, value);
        } else if (SmartOfferBundleKind.PROGRESSIVE.equal(value.kind)) {
            return serialize(SmartOfferBundleProgressive, value);
        } else if (SmartOfferBundleKind.MASTER_SEASON.equal(value.kind)) {
            return serialize(SmartOfferBundleMasterSeason, value);
        } else if (SmartOfferBundleKind.SUNKEN_RUINS.equal(value.kind)) {
            return serialize(SmartOfferBundleSunkenRuins, value);
        } else if (SmartOfferBundleKind.ANCIENT_TREASURE.equal(value.kind)) {
            return serialize(SmartOfferBundleAncientTreasure, value);
        } else if (SmartOfferBundleKind.COLLECTION.equal(value.kind)) {
            return serialize(SmartOfferBundleCollection, value);
        } else if (SmartOfferBundleKind.DAILY_PASS.equal(value.kind)) {
            return serialize(SmartOfferBundleDailyPass, value);
        } else if (SmartOfferBundleKind.DECORATION.equal(value.kind)) {
            return serialize(SmartOfferBundleDecoration, value);
        } else if (SmartOfferBundleKind.HIDDEN_TEMPLE.equal(value.kind)) {
            return serialize(SmartOfferBundleHiddenTemple, value);
        } else if (SmartOfferBundleKind.ALCHEMY.equal(value.kind)) {
            return serialize(SmartOfferBundleAlchemy, value);
        } else if (SmartOfferBundleKind.TIME_LIMITED.equal(value.kind)) {
            return serialize(SmartOfferBundleTimeLimited, value);
        } else if (SmartOfferBundleKind.ANY_PURCHASE.equal(value.kind)) {
            return serialize(SmartOfferBundleAnyPurchase, value);
        } else if (SmartOfferBundleKind.MULTI_TAB.equal(value.kind)) {
            return serialize(SmartOfferBundleMultiTab, value);
        } else if (SmartOfferBundleKind.TREASURE_ACHIEVEMENT.equal(value.kind)) {
            return serialize(SmartOfferBundleTreasureAchievement, value);
        } else if (SmartOfferBundleKind.PLINKO.equal(value.kind)) {
            return serialize(SmartOfferBundlePlinko, value);
        } else if (SmartOfferBundleKind.PLINKO_SHOP_SIMPLE.equal(value.kind)) {
            return serialize(SmartOfferBundlePlinkoShopSimple, value);
        } else if (SmartOfferBundleKind.PLINKO_SHOP_DOUBLE.equal(value.kind)) {
            return serialize(SmartOfferBundlePlinkoShopDouble, value);
        } else if (SmartOfferBundleKind.MAGIC_SPIN.equal(value.kind)) {
            return serialize(SmartOfferBundleMagicSpin, value);
        } else if (SmartOfferBundleKind.TREASURE_OFFER.equal(value.kind)) {
            return serialize(SmartOfferBundleTreasureOffer, value);
        } else if (SmartOfferBundleKind.TREASURE_SHOP.equal(value.kind)) {
            return serialize(SmartOfferBundleTreasureShop, value);
        } else if (SmartOfferBundleKind.ONE_PLUS_TWO.equal(value.kind)) {
            return serialize(SmartOfferBundleOnePlusTwo, value);
        } else if (SmartOfferBundleKind.CARD_BOX_BANK.equal(value.kind)) {
            return serialize(SmartOfferBundleCardBoxBank, value);
        } else if (SmartOfferBundleKind.EXPEDITION_TREASURE_GATE.equal(value.kind)) {
            return serialize(SmartOfferBundleTreasureGate, value);
        } else if (SmartOfferBundleKind.EXPEDITION_TREASURE_TREE.equal(value.kind)) {
            return serialize(SmartOfferBundleTreasureTree, value);
        } else if (SmartOfferBundleKind.NOVICE_BATTLE_PASS.equal(value.kind)) {
            return serialize(SmartOfferBundleNoviceBattlePass, value);
        } else if (SmartOfferBundleKind.PIGGY.equal(value.kind)) {
            return serialize(SmartOfferBundlePiggy, value);
        } else if (SmartOfferBundleKind.REWARD_GIVER.equal(value.kind)) {
            return serialize(SmartOfferBundleRewardGiver, value);
        } else if (SmartOfferBundleKind.CHRISTMAS_HUB.equal(value.kind)) {
            return serialize(SmartOfferBundleChristmasHub, value);
        } else if (SmartOfferBundleKind.CHRISTMAS_CALENDAR.equal(value.kind)) {
            return serialize(SmartOfferBundleChristmasCalendar, value);
        } else if (SmartOfferBundleKind.CHRISTMAS.equal(value.kind)) {
            return serialize(SmartOfferBundleChristmas, value);
        } else if (SmartOfferBundleKind.EXPEDITION_GROUP.equal(value.kind)) {
            return serialize(SmartOfferBundleExpeditionGroup, value);
        } else if (SmartOfferBundleKind.ENERGY_REFILL.equal(value.kind)) {
            return serialize(SmartOfferBundleEnergyRefill, value);
        } else if (SmartOfferBundleKind.FLASH_AD.equal(value.kind)) {
            return serialize(SmartOfferBundleFlashAd, value);
        } else if (SmartOfferBundleKind.MAGICAL_CINEMA.equal(value.kind)) {
            return serialize(SmartOfferBundleMagicalCinema, value);
        } else if (SmartOfferBundleKind.HUB.equal(value.kind)) {
            return serialize(SmartOfferBundleHub, value);
        } else {
            console.error("unknown smart-offer kind");
        }
        return SKIP;
    }

    static deserialize(value) {
        if (SmartOfferBundleKind.SHOP.equal(value.kind)) {
            return deserialize(SmartOfferBundleShop, value);
        } else if (SmartOfferBundleKind.MARKET.equal(value.kind)) {
            return deserialize(SmartOfferBundleMarket, value);
        } else if (SmartOfferBundleKind.CASCADE.equal(value.kind)) {
            return deserialize(SmartOfferBundleCascade, value);
        } else if (SmartOfferBundleKind.FIREFLY.equal(value.kind)) {
            return deserialize(SmartOfferBundleFirefly, value);
        } else if (SmartOfferBundleKind.ACHIEVEMENT.equal(value.kind)) {
            return deserialize(SmartOfferBundleAchievement, value);
        } else if (SmartOfferBundleKind.TREASURE.equal(value.kind)) {
            return deserialize(SmartOfferBundleTreasure, value);
        } else if (SmartOfferBundleKind.PROGRESSIVE.equal(value.kind)) {
            return deserialize(SmartOfferBundleProgressive, value);
        } else if (SmartOfferBundleKind.MASTER_SEASON.equal(value.kind)) {
            return deserialize(SmartOfferBundleMasterSeason, value);
        } else if (SmartOfferBundleKind.SUNKEN_RUINS.equal(value.kind)) {
            return deserialize(SmartOfferBundleSunkenRuins, value);
        } else if (SmartOfferBundleKind.ANCIENT_TREASURE.equal(value.kind)) {
            return deserialize(SmartOfferBundleAncientTreasure, value);
        } else if (SmartOfferBundleKind.COLLECTION.equal(value.kind)) {
            return deserialize(SmartOfferBundleCollection, value);
        } else if (SmartOfferBundleKind.DAILY_PASS.equal(value.kind)) {
            return deserialize(SmartOfferBundleDailyPass, value);
        } else if (SmartOfferBundleKind.DECORATION.equal(value.kind)) {
            return deserialize(SmartOfferBundleDecoration, value);
        } else if (SmartOfferBundleKind.HIDDEN_TEMPLE.equal(value.kind)) {
            return deserialize(SmartOfferBundleHiddenTemple, value);
        } else if (SmartOfferBundleKind.ALCHEMY.equal(value.kind)) {
            return deserialize(SmartOfferBundleAlchemy, value);
        } else if (SmartOfferBundleKind.TIME_LIMITED.equal(value.kind)) {
            return deserialize(SmartOfferBundleTimeLimited, value);
        } else if (SmartOfferBundleKind.ANY_PURCHASE.equal(value.kind)) {
            return deserialize(SmartOfferBundleAnyPurchase, value);
        } else if (SmartOfferBundleKind.MULTI_TAB.equal(value.kind)) {
            return deserialize(SmartOfferBundleMultiTab, value);
        } else if (SmartOfferBundleKind.TREASURE_ACHIEVEMENT.equal(value.kind)) {
            return deserialize(SmartOfferBundleTreasureAchievement, value);
        } else if (SmartOfferBundleKind.PLINKO.equal(value.kind)) {
            return deserialize(SmartOfferBundlePlinko, value);
        } else if (SmartOfferBundleKind.PLINKO_SHOP_SIMPLE.equal(value.kind)) {
            return deserialize(SmartOfferBundlePlinkoShopSimple, value);
        } else if (SmartOfferBundleKind.PLINKO_SHOP_DOUBLE.equal(value.kind)) {
            return deserialize(SmartOfferBundlePlinkoShopDouble, value);
        } else if (SmartOfferBundleKind.MAGIC_SPIN.equal(value.kind)) {
            return deserialize(SmartOfferBundleMagicSpin, value);
        } else if (SmartOfferBundleKind.TREASURE_OFFER.equal(value.kind)) {
            return deserialize(SmartOfferBundleTreasureOffer, value);
        } else if (SmartOfferBundleKind.TREASURE_SHOP.equal(value.kind)) {
            return deserialize(SmartOfferBundleTreasureShop, value);
        } else if (SmartOfferBundleKind.ONE_PLUS_TWO.equal(value.kind)) {
            return deserialize(SmartOfferBundleOnePlusTwo, value);
        } else if (SmartOfferBundleKind.CARD_BOX_BANK.equal(value.kind)) {
            return deserialize(SmartOfferBundleCardBoxBank, value);
        } else if (SmartOfferBundleKind.EXPEDITION_TREASURE_GATE.equal(value.kind)) {
            return deserialize(SmartOfferBundleTreasureGate, value);
        } else if (SmartOfferBundleKind.EXPEDITION_TREASURE_TREE.equal(value.kind)) {
            return deserialize(SmartOfferBundleTreasureTree, value);
        } else if (SmartOfferBundleKind.NOVICE_BATTLE_PASS.equal(value.kind)) {
            return deserialize(SmartOfferBundleNoviceBattlePass, value);
        } else if (SmartOfferBundleKind.PIGGY.equal(value.kind)) {
            return deserialize(SmartOfferBundlePiggy, value);
        } else if (SmartOfferBundleKind.REWARD_GIVER.equal(value.kind)) {
            return deserialize(SmartOfferBundleRewardGiver, value);
        } else if (SmartOfferBundleKind.CHRISTMAS_HUB.equal(value.kind)) {
            return deserialize(SmartOfferBundleChristmasHub, value);
        } else if (SmartOfferBundleKind.CHRISTMAS_CALENDAR.equal(value.kind)) {
            return deserialize(SmartOfferBundleChristmasCalendar, value);
        } else if (SmartOfferBundleKind.CHRISTMAS.equal(value.kind)) {
            return deserialize(SmartOfferBundleChristmas, value);
        } else if (SmartOfferBundleKind.EXPEDITION_GROUP.equal(value.kind)) {
            return deserialize(SmartOfferBundleExpeditionGroup, value);
        } else if (SmartOfferBundleKind.ENERGY_REFILL.equal(value.kind)) {
            return deserialize(SmartOfferBundleEnergyRefill, value);
        } else if (SmartOfferBundleKind.FLASH_AD.equal(value.kind)) {
            return deserialize(SmartOfferBundleFlashAd, value);
        } else if (SmartOfferBundleKind.MAGICAL_CINEMA.equal(value.kind)) {
            return deserialize(SmartOfferBundleMagicalCinema, value);
        } else if (SmartOfferBundleKind.HUB.equal(value.kind)) {
            return deserialize(SmartOfferBundleHub, value);
        } else {
            console.error("unknown smart-offer kind");
        }
        return SKIP;
    }

    static schema() {
        return list(custom(
            (value) => SmartOfferBundleUtils.serialize(value),
            (value) => SmartOfferBundleUtils.deserialize(value)
        ))
    }

}
